// Copyright (c) 2017 Deere & Company

import LaborRateAccordion from './labor-rate-accordion';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    laborRateChanges: state.tcsm.wip.laborRateChanges,
    laborRateChangesSearchFilters: state.tcsm.wip.laborRateChangesSearchFilters,
    length: state.tcsm.wip.laborRateChangesLength
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(LaborRateAccordion);



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/labor-rate-changes/index.js